import PropTypes from "prop-types";
import { Accounts } from "vino/components";

const Block = ({ attributes }) => {
	return <Accounts attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
